import { makeAuthenticatedRequest } from '@/services/api/client'

/**
 * Ported from the Vue app's services/ (purchaseApiService). The logic is
 * framework-agnostic — this is a near-direct lift, just typed and pointed at
 * the shared client. Components NEVER call axios directly (Definition of Done).
 */
export interface Vendor {
  id: number
  name: string
  gst_number?: string
  payment_terms?: string
  email?: string
  phone?: string
}

export function listVendors() {
  return makeAuthenticatedRequest<Vendor[]>({ url: '/purchase/vendors', method: 'GET' })
}

export function getVendor(id: number) {
  return makeAuthenticatedRequest<Vendor>({ url: `/purchase/vendors/${id}`, method: 'GET' })
}
